/*
 * Public API Surface of attached-app
 */

export * from './pages/attached.component';
export * from './lib/attached.module';
